// extracted by mini-css-extract-plugin
module.exports = {"root":"images_root___76Lp","imgContainer":"images_imgContainer__JdMk7"};